// import './jquery'
import '@fancyapps/fancybox'

let pageItems = []

export default {
  install(Vue, options) {
    Vue.directive('fancy-box', {
      bind: function (el, binding, vnode) {

        const defaultOptions = {
          infobar: false,
          smallBtn: true,
          toolbar: false,
          protect: false,
          image: {
            preload: true
          },
          animationEffect: "zoom", // false | "zoom" | "fade" | "zoom-in-out"
          transitionEffect: "slide",
          btnTpl: {
            arrowLeft: `
            <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
                <i class="icon-arrow-left icon-lg"></i>
            </button>
            `,
            arrowRight: `
            <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
                <i class="icon-arrow-right icon-lg"></i>
            </button>
            `,
            smallBtn: `
            <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                <i class="icon-close icon-lg"></i>
            </button>
            `,
          },
          // thumbs: {
          //     autoStart: true, // Display thumbnails on opening
          //     hideOnClose: true, // Hide thumbnail grid when closing animation starts
          //     parentEl: ".fancybox-container", // Container is injected into this element
          //     axis: "x" // Vertical (y) or horizontal (x) scrolling
          // },
        }

        let galleryOptions
        galleryOptions = Object.assign(defaultOptions, options);
        galleryOptions = Object.assign(options, binding.value);

        pageItems.push(vnode)

        el.addEventListener("click", function (event) {
          event.preventDefault();

          let directives = [],
            items = [],
            index = 0,
            $target = $(event.currentTarget).trigger("blur");

          if (binding.arg) {
            directives = pageItems.filter(directive => directive.data.directives[0].arg === binding.arg)
          } else {
            items.push(el)
          }

          directives.forEach(function (item, i) {
            items.push(item.elm)

            if (item.elm === $target[0]) {
              index = i
            }
          })

          $.fancybox.open(items, galleryOptions, index)
        });
      },
      inserted: function (el) {}
    })
  }
};